import { fetch } from '@/shared/fetch';

export const endConsultation = async (
    consultationUid: string,
): Promise<void> => {
    return await fetch(
        `/api/caregiverspace/consultations/${consultationUid}/end-consultation`,
        'POST',
    );
};
